import { replaceVariableInDependency } from "@/lib/canvas/assets/dom-utils";

export function createStyleTagWithRawCssCodeInside(
  document: Document,
  rawCssCode: string,
  tagId: string
): HTMLStyleElement {
  const newTag = document.createElement("style");
  newTag.innerHTML = rawCssCode;
  newTag.id = tagId;

  return newTag;
}

export function createLinkRelStylesheetTagWithGivenUrl(
  document: Document,
  stylesheetUrl: string,
  tagId: string
): HTMLLinkElement {
  const newTag = document.createElement("link");

  newTag.id = tagId;
  newTag.href = replaceVariableInDependency(
    stylesheetUrl,
    // Needed for tests
    window.Breakdance.stores.configStore.neededData?.elementsPluginUrl,
    window.Breakdance.stores.configStore.neededData
      ?.elementsReusableDependenciesUrls
  );
  newTag.rel = "stylesheet";

  return newTag;
}

export function insertBeforeElement(
  insertBeforeWhat: Node,
  whatToInsert: Node
): void {
  insertBeforeWhat.parentNode?.insertBefore(whatToInsert, insertBeforeWhat);
}

export function runCallbackIfElementIsNotVisibleInRoot(
  callback: () => void,
  element: HTMLElement | Element,
  options: IntersectionObserverInit
) {
  const observer = new IntersectionObserver(entries => {
    // It'll execute right away when called with ".observe".
    // Disconnecting it on the callback makes it run only once
    observer.disconnect();

    entries.forEach(entry => {
      // don't scroll to element if any part of it is visible
      // If the user can select it,they can scroll to it.
      // They could also start a drag operation on it and we don't want to scroll while dragging
      if (entry.isIntersecting && entry.intersectionRatio > 0) {
        return;
      }

      callback();
    });
  }, options);

  observer.observe(element);
}

export function getDocumentHead(document: Document): HTMLHeadElement {
  const headElement = document.querySelector("head");

  if (!headElement) {
    // todo
    throw "how in the fuck is there no head element... we need to change the UI to an error state in this case";
  }

  return headElement;
}

declare global {
  // IDK why TS doesn't include this by default because obivously everything is a member of Window
  // Have to define this explicitly to avoid using ts-ignore below
  interface Window {
    HTMLElement: typeof HTMLElement;
  }
}

export const isNodeOfIframeWindowIsHtmlElement = (
  node: Node,
  iframeWindow: Window
): node is HTMLElement => {
  // window.HTMLElement !== iframeWindow.HTMLElement,
  // that's why plain "instanceof HTMLElement" won't work for iframe's elements
  // I spent 2 hours debugging this shit
  const iframesHtmlElementClass = iframeWindow.HTMLElement;

  // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
  const nodeIsElement = node.nodeType === 1;

  return nodeIsElement && node instanceof iframesHtmlElementClass;
};

export function decodeHtmlEntities(str: string) {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
}
